"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("../errors");
const api_1 = require("../api");
const handleError_1 = require("./handleError");
const pollRequest = (_a) => __awaiter(void 0, [_a], void 0, function* ({ path, requestConfig, query, isFinalResponse, interval = 5000, timeout, attempts = 1, signal, }) {
    try {
        if (hasReachedMaxDuration({ interval, timeout, attempts })) {
            throw new errors_1.PollDurationError();
        }
        else {
            yield new Promise((resolve, reject) => {
                const timeoutId = setTimeout(resolve, interval);
                signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', () => {
                    clearTimeout(timeoutId);
                    reject(new errors_1.PollRequestAbortedError());
                });
            });
        }
        const response = yield (0, api_1.get)({ path, config: requestConfig, query });
        if (isFinalResponse(response)) {
            return response;
        }
        else if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
            throw new errors_1.PollRequestAbortedError();
        }
        else {
            return pollRequest({
                path,
                requestConfig,
                query,
                isFinalResponse,
                interval,
                timeout,
                attempts: attempts + 1,
                signal,
            });
        }
    }
    catch (err) {
        (0, handleError_1.default)(err, errors_1.ReportPollError);
    }
});
const hasReachedMaxDuration = ({ interval, timeout, attempts, }) => {
    return timeout && interval * attempts > timeout;
};
exports.default = pollRequest;
